export default __webpack_public_path__ + "static/media/cy.070012f5.svg";